import { useState, useEffect } from "react";

const SUPABASE_URL = "https://xqdbeericwrddaatrhha.supabase.co";
const SUPABASE_KEY = "sb_publishable_2pOY8vXmfwDfI9liEIPhfg_ogD-nTN9";

async function fetchSubscribers() {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/subscribers?select=*&order=created_at.desc`, {
    headers: {
      "apikey": SUPABASE_KEY,
      "Authorization": `Bearer ${SUPABASE_KEY}`,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) throw new Error("فشل في جلب البيانات");
  return res.json();
}

const planColors = {
  Enterprise: { accent: "#e94560" },
  Pro: { accent: "#60a5fa" },
  Starter: { accent: "#4ade80" },
};

const statusConfig = {
  active: { label: "نشط", color: "#4ade80", dot: "#22c55e" },
  expired: { label: "منتهي", color: "#f87171", dot: "#ef4444" },
  trial: { label: "تجريبي", color: "#facc15", dot: "#eab308" },
};

export default function AltshiftDashboard() {
  const [view, setView] = useState("admin");
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterPlan, setFilterPlan] = useState("all");
  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    fetchSubscribers()
      .then(data => { setSubscribers(data); setSelectedClient(data[0]); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  const filtered = subscribers.filter(s => {
    const matchSearch = s.name?.includes(searchQuery) || s.email?.includes(searchQuery);
    const matchStatus = filterStatus === "all" || s.status === filterStatus;
    const matchPlan = filterPlan === "all" || s.plan === filterPlan;
    return matchSearch && matchStatus && matchPlan;
  });

  const totalActive = subscribers.filter(s => s.status === "active").length;
  const totalExpired = subscribers.filter(s => s.status === "expired").length;
  const totalMessages = subscribers.reduce((a, s) => a + (s.messages || 0), 0);

  if (loading) return (
    <div dir="rtl" style={{
      minHeight: "100vh", background: "#0a0a0f", display: "flex",
      alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16,
      fontFamily: "'IBM Plex Sans Arabic', 'Tajawal', sans-serif",
    }}>
      <style>{`@keyframes slide { 0%{transform:translateX(-100%)} 100%{transform:translateX(300%)} }`}</style>
      <div style={{ fontSize: 36 }}>⚡</div>
      <div style={{ color: "#6366f1", fontSize: 16, fontWeight: 600 }}>جاري تحميل البيانات من Supabase...</div>
      <div style={{ width: 200, height: 4, background: "#1e1e3a", borderRadius: 999, overflow: "hidden" }}>
        <div style={{ height: "100%", width: "60%", background: "linear-gradient(90deg, #6366f1, #8b5cf6)", borderRadius: 999, animation: "slide 1.5s infinite" }} />
      </div>
    </div>
  );

  if (error) return (
    <div dir="rtl" style={{
      minHeight: "100vh", background: "#0a0a0f", display: "flex",
      alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12,
      fontFamily: "'IBM Plex Sans Arabic', 'Tajawal', sans-serif", color: "#f87171",
    }}>
      <div style={{ fontSize: 36 }}>⚠️</div>
      <div style={{ fontSize: 16 }}>خطأ: {error}</div>
      <button onClick={() => window.location.reload()} style={{
        background: "#6366f1", border: "none", borderRadius: 8, padding: "10px 24px",
        color: "#fff", fontSize: 14, cursor: "pointer", marginTop: 8, fontFamily: "inherit",
      }}>إعادة المحاولة</button>
    </div>
  );

  return (
    <div dir="rtl" style={{ minHeight: "100vh", background: "#0a0a0f", color: "#e8e8f0", fontFamily: "'IBM Plex Sans Arabic', 'Tajawal', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@300;400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-thumb { background: #2a2a3e; border-radius: 2px; }
        .card-hover { transition: transform 0.2s, box-shadow 0.2s; }
        .card-hover:hover { transform: translateY(-3px); box-shadow: 0 8px 30px rgba(99,102,241,0.15) !important; }
        .row-hover:hover { background: rgba(99,102,241,0.08) !important; cursor: pointer; }
        .fade-in { opacity: 0; transform: translateY(12px); animation: fadeUp 0.4s forwards; }
        @keyframes fadeUp { to { opacity: 1; transform: translateY(0); } }
        .pulse { animation: pulse 2s infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
        input:focus, select:focus { outline: none; }
        button { font-family: inherit; }
      `}</style>

      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg, #0d0d1a, #12122a)", borderBottom: "1px solid #1e1e3a",
        padding: "14px 28px", display: "flex", alignItems: "center", justifyContent: "space-between",
        position: "sticky", top: 0, zIndex: 100,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, background: "linear-gradient(135deg, #6366f1, #8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>⚡</div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>altshift</div>
            <div style={{ fontSize: 11, color: "#6366f1", fontWeight: 500 }}>Chatbot Dashboard</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 4, background: "#111128", borderRadius: 10, padding: 4, border: "1px solid #1e1e3a" }}>
          {[{ id: "admin", label: "إدارة" }, { id: "client", label: "عميل" }].map(v => (
            <button key={v.id} onClick={() => setView(v.id)} style={{
              padding: "6px 18px", borderRadius: 7, fontSize: 13, fontWeight: 600, border: "none", cursor: "pointer",
              background: view === v.id ? "linear-gradient(135deg, #6366f1, #8b5cf6)" : "transparent",
              color: view === v.id ? "#fff" : "#6a6a8a", transition: "all 0.2s",
            }}>{v.label}</button>
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ textAlign: "left" }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{view === "admin" ? "فريق altshift" : selectedClient?.name}</div>
            <div style={{ fontSize: 11, color: "#4a4a6a" }}>{view === "admin" ? `${subscribers.length} مشترك` : selectedClient?.plan}</div>
          </div>
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: "linear-gradient(135deg, #6366f1, #8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "#fff" }}>
            {view === "admin" ? "A" : (selectedClient?.avatar || "؟")}
          </div>
        </div>
      </div>

      {view === "admin" ? (
        <AdminView filtered={filtered} searchQuery={searchQuery} setSearchQuery={setSearchQuery}
          filterStatus={filterStatus} setFilterStatus={setFilterStatus}
          filterPlan={filterPlan} setFilterPlan={setFilterPlan}
          totalActive={totalActive} totalExpired={totalExpired} totalMessages={totalMessages}
          setSelectedClient={setSelectedClient} setView={setView} />
      ) : (
        <ClientView subscriber={selectedClient} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}
    </div>
  );
}

function StatCard({ label, value, sub, accent, delay = 0, icon }) {
  return (
    <div className="card-hover fade-in" style={{
      background: "linear-gradient(135deg, #0d0d1a, #12122a)", border: "1px solid #1e1e3a",
      borderRadius: 14, padding: "20px 22px", animationDelay: `${delay}s`, position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", top: 0, right: 0, width: 80, height: 80, background: `radial-gradient(circle, ${accent}18 0%, transparent 70%)`, borderRadius: "0 14px 0 80px" }} />
      <div style={{ fontSize: 22, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: "#fff" }}>{value}</div>
      <div style={{ fontSize: 13, color: "#6a6a8a", marginTop: 3 }}>{label}</div>
      {sub && <div style={{ fontSize: 11, color: accent, marginTop: 6, fontWeight: 500 }}>{sub}</div>}
    </div>
  );
}

function AdminView({ filtered, searchQuery, setSearchQuery, filterStatus, setFilterStatus, filterPlan, setFilterPlan, totalActive, totalExpired, totalMessages, setSelectedClient, setView }) {
  return (
    <div style={{ padding: "24px 28px", maxWidth: 1200, margin: "0 auto" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14, marginBottom: 24 }}>
        <StatCard label="إجمالي المشتركين" value={filtered.length} sub="كل الخطط" accent="#6366f1" delay={0} icon="👥" />
        <StatCard label="نشطين" value={totalActive} accent="#4ade80" delay={0.05} icon="✅" />
        <StatCard label="منتهيين" value={totalExpired} sub="بحاجة تجديد" accent="#f87171" delay={0.1} icon="⚠️" />
        <StatCard label="إجمالي الرسائل" value={`${(totalMessages/1000).toFixed(0)}K`} accent="#60a5fa" delay={0.15} icon="💬" />
      </div>

      <div className="fade-in" style={{ background: "#0d0d1a", border: "1px solid #1e1e3a", borderRadius: 14, padding: "14px 18px", marginBottom: 16, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", animationDelay: "0.2s" }}>
        <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="🔍  ابحث..."
          style={{ flex: 1, minWidth: 160, background: "#111128", border: "1px solid #1e1e3a", borderRadius: 8, padding: "8px 14px", color: "#e8e8f0", fontSize: 13 }} />
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={{ background: "#111128", border: "1px solid #1e1e3a", borderRadius: 8, padding: "8px 12px", color: "#e8e8f0", fontSize: 13, cursor: "pointer" }}>
          <option value="all">كل الحالات</option>
          <option value="active">نشط</option>
          <option value="expired">منتهي</option>
          <option value="trial">تجريبي</option>
        </select>
        <select value={filterPlan} onChange={e => setFilterPlan(e.target.value)} style={{ background: "#111128", border: "1px solid #1e1e3a", borderRadius: 8, padding: "8px 12px", color: "#e8e8f0", fontSize: 13, cursor: "pointer" }}>
          <option value="all">كل الخطط</option>
          <option value="Enterprise">Enterprise</option>
          <option value="Pro">Pro</option>
          <option value="Starter">Starter</option>
        </select>
        <span style={{ fontSize: 12, color: "#4a4a6a" }}>{filtered.length} نتيجة</span>
      </div>

      <div className="fade-in" style={{ background: "#0d0d1a", border: "1px solid #1e1e3a", borderRadius: 14, overflow: "hidden", animationDelay: "0.25s" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#111128", borderBottom: "1px solid #1e1e3a" }}>
              {["المشترك", "الخطة", "الحالة", "التجديد", "الرسائل", "الجلسات", "الدفع", ""].map(h => (
                <th key={h} style={{ padding: "12px 16px", fontSize: 12, color: "#6a6a8a", fontWeight: 600, textAlign: "right" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map(s => {
              const st = statusConfig[s.status] || statusConfig.trial;
              const pl = planColors[s.plan] || { accent: "#6366f1" };
              return (
                <tr key={s.id} className="row-hover" style={{ borderBottom: "1px solid #0f0f1e" }}
                  onClick={() => { setSelectedClient(s); setView("client"); }}>
                  <td style={{ padding: "13px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 34, height: 34, borderRadius: 9, background: `${pl.accent}22`, border: `1px solid ${pl.accent}44`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: pl.accent, flexShrink: 0 }}>
                        {s.avatar || s.name?.[0]}
                      </div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{s.name}</div>
                        <div style={{ fontSize: 11, color: "#4a4a6a" }}>{s.email}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "13px 16px" }}>
                    <span style={{ background: `${pl.accent}18`, color: pl.accent, border: `1px solid ${pl.accent}33`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 600 }}>{s.plan}</span>
                  </td>
                  <td style={{ padding: "13px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <div className="pulse" style={{ width: 7, height: 7, borderRadius: "50%", background: st.dot }} />
                      <span style={{ fontSize: 12, color: st.color, fontWeight: 500 }}>{st.label}</span>
                    </div>
                  </td>
                  <td style={{ padding: "13px 16px", fontSize: 12, color: "#8a8aaa" }}>{s.renew_date}</td>
                  <td style={{ padding: "13px 16px", fontSize: 13, fontWeight: 600, color: "#fff" }}>{(s.messages || 0).toLocaleString()}</td>
                  <td style={{ padding: "13px 16px", fontSize: 13, fontWeight: 600, color: "#fff" }}>{(s.sessions || 0).toLocaleString()}</td>
                  <td style={{ padding: "13px 16px", fontSize: 13, fontWeight: 600, color: s.paid > 0 ? "#4ade80" : "#facc15" }}>
                    {s.paid > 0 ? `${s.paid} ${s.currency}` : "تجريبي"}
                  </td>
                  <td style={{ padding: "13px 16px" }}>
                    <button style={{ background: "linear-gradient(135deg, #6366f1, #8b5cf6)", border: "none", borderRadius: 7, padding: "6px 14px", color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>عرض</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filtered.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "#4a4a6a" }}>لا توجد نتائج</div>}
      </div>
    </div>
  );
}

function ClientView({ subscriber: s, activeTab, setActiveTab }) {
  if (!s) return null;
  const st = statusConfig[s.status] || statusConfig.trial;
  const planLimits = { Enterprise: 150000, Pro: 50000, Starter: 10000 };
  const limit = planLimits[s.plan] || 10000;
  const usagePercent = Math.min(((s.messages || 0) / limit) * 100, 100);

  return (
    <div style={{ padding: "24px 28px", maxWidth: 900, margin: "0 auto" }}>
      <div className="fade-in" style={{ background: "linear-gradient(135deg, #0d0d1a, #12122a)", border: "1px solid #1e1e3a", borderRadius: 16, padding: "22px 26px", marginBottom: 22, display: "flex", alignItems: "center", gap: 20, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -40, left: -40, width: 180, height: 180, background: "radial-gradient(circle, #6366f115, transparent 70%)", borderRadius: "50%" }} />
        <div style={{ width: 60, height: 60, borderRadius: 14, background: "linear-gradient(135deg, #6366f1, #8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
          {s.avatar || s.name?.[0]}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#fff" }}>{s.name}</div>
          <div style={{ fontSize: 13, color: "#6a6a8a", marginTop: 2 }}>{s.email}</div>
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            <span style={{ background: "#6366f122", border: "1px solid #6366f144", borderRadius: 6, padding: "3px 12px", fontSize: 12, color: "#818cf8", fontWeight: 600 }}>خطة {s.plan}</span>
            <span style={{ display: "flex", alignItems: "center", gap: 5, background: `${st.dot}15`, border: `1px solid ${st.dot}33`, borderRadius: 6, padding: "3px 12px", fontSize: 12, color: st.color, fontWeight: 600 }}>
              <div className="pulse" style={{ width: 6, height: 6, borderRadius: "50%", background: st.dot }} />{st.label}
            </span>
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 11, color: "#4a4a6a" }}>تجديد في</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", marginTop: 4 }}>{s.renew_date}</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 4, marginBottom: 20, background: "#0d0d1a", borderRadius: 10, padding: 4, border: "1px solid #1e1e3a", width: "fit-content" }}>
        {[{ id: "overview", label: "نظرة عامة" }, { id: "usage", label: "الاستخدام" }, { id: "billing", label: "الفواتير" }].map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
            padding: "7px 18px", borderRadius: 7, fontSize: 13, fontWeight: 600, border: "none", cursor: "pointer", transition: "all 0.2s",
            background: activeTab === t.id ? "linear-gradient(135deg, #6366f1, #8b5cf6)" : "transparent",
            color: activeTab === t.id ? "#fff" : "#6a6a8a",
          }}>{t.label}</button>
        ))}
      </div>

      {activeTab === "overview" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          <StatCard label="الرسائل المرسلة" value={(s.messages||0).toLocaleString()} accent="#6366f1" delay={0} icon="💬" />
          <StatCard label="الجلسات" value={(s.sessions||0).toLocaleString()} accent="#60a5fa" delay={0.05} icon="🔁" />
          <StatCard label="تاريخ الانضمام" value={s.start_date || "-"} accent="#4ade80" delay={0.1} icon="📅" />
          <StatCard label="المدفوع" value={s.paid > 0 ? `${s.paid} ${s.currency}` : "تجريبي"} accent="#f59e0b" delay={0.15} icon="💳" />
        </div>
      )}

      {activeTab === "usage" && (
        <div className="fade-in" style={{ background: "#0d0d1a", border: "1px solid #1e1e3a", borderRadius: 14, padding: 24 }}>
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
              <span style={{ fontSize: 14, fontWeight: 600, color: "#fff" }}>استهلاك الرسائل</span>
              <span style={{ fontSize: 13, color: "#6a6a8a" }}>{(s.messages||0).toLocaleString()} / {limit.toLocaleString()}</span>
            </div>
            <div style={{ background: "#111128", borderRadius: 999, height: 10, overflow: "hidden" }}>
              <div style={{ width: `${usagePercent}%`, height: "100%", borderRadius: 999, transition: "width 1s ease", background: usagePercent > 85 ? "linear-gradient(90deg,#ef4444,#f87171)" : usagePercent > 60 ? "linear-gradient(90deg,#f59e0b,#fbbf24)" : "linear-gradient(90deg,#6366f1,#8b5cf6)" }} />
            </div>
            <div style={{ fontSize: 12, color: "#4a4a6a", marginTop: 6 }}>{(100-usagePercent).toFixed(1)}% متبقي</div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
            {[
              { label: "رسالة/يوم", value: Math.round((s.messages||0)/30), icon: "📊" },
              { label: "رسائل/جلسة", value: s.sessions ? Math.round(s.messages/s.sessions) : 0, icon: "💡" },
              { label: "حد الباقة", value: `${(limit/1000).toFixed(0)}K`, icon: "📈" },
            ].map(item => (
              <div key={item.label} style={{ background: "#111128", border: "1px solid #1e1e3a", borderRadius: 12, padding: 16, textAlign: "center" }}>
                <div style={{ fontSize: 20, marginBottom: 8 }}>{item.icon}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: "#fff" }}>{item.value}</div>
                <div style={{ fontSize: 11, color: "#4a4a6a", marginTop: 4 }}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === "billing" && (
        <div className="fade-in" style={{ background: "#0d0d1a", border: "1px solid #1e1e3a", borderRadius: 14, overflow: "hidden" }}>
          <div style={{ padding: "14px 20px", borderBottom: "1px solid #111128", background: "#111128" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#6a6a8a" }}>سجل المدفوعات</span>
          </div>
          {s.paid > 0 ? [1,2,3].map(i => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 20px", borderBottom: "1px solid #111128" }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>اشتراك {s.plan} — شهر {i}</div>
                <div style={{ fontSize: 11, color: "#4a4a6a", marginTop: 2 }}>{new Date(2024, i+8, 1).toLocaleDateString("ar-SA")}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: "#4ade80" }}>{s.paid} {s.currency}</span>
                <span style={{ background: "#4ade8015", border: "1px solid #4ade8033", borderRadius: 6, padding: "3px 10px", fontSize: 11, color: "#4ade80" }}>مدفوع</span>
              </div>
            </div>
          )) : (
            <div style={{ padding: 30, textAlign: "center", color: "#facc15", fontSize: 14 }}>حساب تجريبي — لا توجد فواتير</div>
          )}
        </div>
      )}
    </div>
  );
}
